(() => {
  /**
   * Move one complete gallery frame at a time. Keeping this behavior local to
   * the section preserves native touch scrolling while adding keyboard-friendly controls.
   */
  const bindGallery = (gallery) => {
    if (gallery.dataset.sliderReady === 'true') return;

    const track = gallery.querySelector('[data-slider-track]');
    const previous = gallery.querySelector('[data-slider-prev]');
    const next = gallery.querySelector('[data-slider-next]');
    if (!track || !previous || !next) return;

    const move = (direction) => {
      // The mobile PDP pattern leaves the next slide peeking into view, so step
      // by one slide plus its gap instead of by the wider viewport.
      const firstSlide = track.firstElementChild;
      const gap = Number.parseFloat(getComputedStyle(track).gap) || 0;
      const step = firstSlide ? firstSlide.getBoundingClientRect().width + gap : track.clientWidth;
      track.scrollBy({ left: direction * step, behavior: 'smooth' });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    gallery.dataset.sliderReady = 'true';
  };

  const initialize = (root = document) => {
    root.querySelectorAll('[data-grounding-compare] [data-slider]').forEach(bindGallery);
  };

  initialize();

  // Shopify replaces sections without reloading the page inside the theme editor.
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
